import React from 'react';
import styles from './Frame.module.css';
import { useClassName } from '../hooks';

type FrameProps = {
  children?: React.ReactNode;
  className?: string;
};

const Frame: React.FC<React.PropsWithChildren<FrameProps>> = ({
  children,
  className
}) => {
  const cx = useClassName(styles['tk-frame'], className);

  return <div className={cx}>{children}</div>;
};

export default Frame;
